import modules from '~/config/modules'

export default function ({
}, inject) {
    const modulesConfig = modules[process.env.brand]
	inject('modulesConfig', modulesConfig)
}